import { render, staticRenderFns } from "./RepliesAndComments.vue?vue&type=template&id=f82cf5cc&scoped=true"
import script from "./RepliesAndComments.vue?vue&type=script&lang=js"
export * from "./RepliesAndComments.vue?vue&type=script&lang=js"
import style0 from "./RepliesAndComments.vue?vue&type=style&index=0&id=f82cf5cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82cf5cc",
  null
  
)

export default component.exports